// Global application configuration
export const APP_CONFIG = {
  // Brand assets - Using SVG from public folder for better quality and smaller size
  LOGO_URL: "/tadreamk_logo.svg",

  // Company information
  COMPANY_NAME: "TadReamk",
  COMPANY_DESCRIPTION:
    "Empowering innovation through comprehensive trademark and patent solutions. Protect, monitor, and support community logo creation with confidence.",

  // API Configuration
  API_BASE_URL: process.env.REACT_APP_API_URL || "http://localhost:2506/api/v1",
  API_ERP_URL:
    process.env.REACT_APP_API_ERP_URL || "http://localhost:2516/api/v1",

  // External Services
  BUSINESS_CARD_SERVICE_URL:
    process.env.REACT_APP_BUSINESS_CARD_URL || "http://localhost:3001",
  LACE_MATERIAL_SERVICE_URL:
    process.env.REACT_APP_LACE_MATERIAL_URL || "http://localhost:3002",
  TADREAMK_EYE_URL:
    process.env.REACT_APP_TADREAMK_EYE_URL || "http://search.tadreamk.com/",
  TADREAMK_CREATE_URL:
    process.env.REACT_APP_TADREAMK_CREATE_URL || "http://tc-dev.tadreamk.com",
  TADREAMK_PATENT_URL:
    process.env.REACT_APP_TADREAMK_PATENT_URL ||
    "http://ts-dev.tadreamk.com/patent",
  TADREAMK_SURVEILLANCE_URL:
    process.env.REACT_APP_TADREAMK_SURVEILLANCE_URL ||
    "http://ts-dev.tadreamk.com",
  TRADEMARK_TRADING_URL:
    process.env.REACT_APP_TRADEMARK_TRADING_URL || "https://tadreamk.com/logos",

  // Google OAuth Configuration
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || "",

  // Social media links
  SOCIAL_LINKS: {
    LINKEDIN: "https://www.linkedin.com/company/tadreamk/",
    GITHUB: "https://github.com/tadreamk/tadreamk-python",
  },
};
